import React, { useEffect } from 'react';

export default function HubSpotNewClientForm() {
    useEffect(() => {
        const target = document.getElementById('hubspotNewClientForm');
        if (!target) return;

        target.innerHTML = '';

        const run = () => {
            if (!window.hbspt) return;

            target.innerHTML = '';

            window.hbspt.forms.create({
                portalId: '5688825',
                formId: 'f7c7d744-ce6a-4697-9b74-c8caf4492f95',
                region: 'na1',
                target: '#hubspotNewClientForm',
            });
        };

        const existingScript = document.querySelector(
            'script[src="https://js.hsforms.net/forms/embed/v2.js"]'
        );

        if (window.hbspt) {
            setTimeout(run, 0);
        } else if (existingScript) {
            existingScript.addEventListener('load', run, { once: true });
        } else {
            const script = document.createElement('script');
            script.src = 'https://js.hsforms.net/forms/embed/v2.js';
            script.async = true;
            script.onload = run;
            document.body.appendChild(script);
        }

        return () => {
            if (target) target.innerHTML = '';
        };
    }, []);

    return <div id="hubspotNewClientForm" className="hubspotFormWrap" />;
}
